// @ts-nocheck
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetOrdersApiParameter>;

export const DispatchUpdateParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderHistory/UpdateParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateParameter];

const updateParameter = createHandlerChainRunner(chain, "UpdateParameter");
export default updateParameter;
